//=> https://developers.google.com/analytics/devguides/collection/ga4/reference/events#add_to_cart

class AddToCartEventListener {
    // Language: javascript
    // Path: AddToCartEventListener.js
    // Compare this snippet from EventListener.js:
    get ProductList() {
        return ".gtm-product-list";
    }
    get AddTypes() {
        return {
            category_product_list: "Category Product List",
            related_product_list: "Related Product List",
            lastview_product_list: "LastView Product List",
        };
    }

    constructor(element, eventName = "click") {
        this.element = element;
        this.eventName = eventName;
    }
    callback() {
        const dataLayer = new DataLayer();
        dataLayer.clear();

        var addtype = document.querySelector(
            AddToCartEventListener.prototype.ProductList
        )
            ? document.querySelector(
                  AddToCartEventListener.prototype.ProductList
              ).dataset.addtype
            : null;
        var analyticsData = this.dataset.analytics
            ? JSON.parse(this.dataset.analytics)
            : null;

        if (analyticsData && this.dataset) {
            var analticsDataProducts = analyticsData.products
                ? analyticsData.products[0]
                : null;
            var addToCartAmount = document.querySelector(
                '[name="addToCartAmount"][data-id="' +
                    analticsDataProducts.id +
                    '"]'
            );
            var quantity = parseFloat(
                !!addToCartAmount ? addToCartAmount.value : 1
            );
            var item_list_id = addtype ? addtype : "base";

            var price = Number(
                analticsDataProducts.price
                    ? analticsDataProducts.price.replace(",", ".")
                    : this.dataset.price.replace(",", ".")
            ).toFixed(2);
            var pricewithdiscount = Number(
                analticsDataProducts.pricewithdiscount
                    ? analticsDataProducts.pricewithdiscount.replace(",", ".")
                    : this.dataset.priceWithDiscount.replace(",", ".")
            ).toFixed(2);

            var item = {
                item_id: this.dataset.code
                    ? this.dataset.code
                    : analticsDataProducts.code,
                item_name: analticsDataProducts.name,
                currency: analticsDataProducts.currency,
                item_brand: analticsDataProducts.brand,
                item_category: analticsDataProducts.category,
                item_list_id: item_list_id,
                price: pricewithdiscount,
                quantity: quantity ? quantity : this.dataset.quantity,
            };
            if (analticsDataProducts.categories) {
                var splitCategories =
                    analticsDataProducts.categories.split(";");
                for (var i = 0; i < splitCategories.length; i++) {
                    if (i == 0) {
                        item["item_category"] = splitCategories[i];
                    } else {
                        item["item_category" + i] = splitCategories[i];
                    }
                }
            }
            if (this.dataset.addtype) {
                item["item_list_id"] = this.dataset.addtype;
            }

            if (this.dataset.variant) {
                var variant = JSON.parse(this.dataset.variant);
                if (variant) {
                    item["item_variant"] = Object.values(variant).join(",");
                }
            }
            if (price != pricewithdiscount) {
                item["price"] = price;
                item["discount"] = (price - pricewithdiscount).toFixed(2);
            }

            dataLayer
                .push({
                    // eslint-disable-line
                    event: "add_to_cart",
                    ecommerce: {
                        items: [item],
                    },
                })
                .then(() => {
                    console.log("GTM pushed add_to_cart event");
                    setTimeout(() => {
                        var instanceActivate = new ActivateGtm();
                        instanceActivate.activateRemoveFromCart();
                    }, 1000);
                })
                .catch((error) => {
                    console.warn("GTM error add_to_cart event", error);
                });

            if (typeof gtag !== "undefined" && !!gtag) {
                gtag("event", "add_to_cart", {
                    event_category: "Enhanced Ecommerce",
                    event_label: "add to cart",
                    items: [item],
                });
            }
        }
    }

    listen() {
        this.element.addEventListener(
            this.eventName,
            AddToCartEventListener.prototype.callback
        );
    }
    remove() {
        this.element.removeEventListener(
            this.eventName,
            AddToCartEventListener.prototype.callback
        );
    }
}
